import { useState, useEffect, MutableRefObject } from 'react';
import { RangerPick } from './styles';
import ptBr from 'antd/es/date-picker/locale/pt_BR';
import moment from 'moment';
import { forwardRef } from 'react';
import { Button } from '../Button';
import { useScreenWidth } from 'utils/useScreenWidth';
import dayjs, { Dayjs } from 'dayjs';
import useAlert from 'components/Notification';
import { useNavigate } from 'react-router-dom';
import { useUpdateQueryParams } from 'hooks/useUpdateQueryParam';
import { useSessionStorage } from 'context/sessionStorage';
import { useAnyProvider } from 'hooks/Context';

type InputDateProps = {
  date: any;
  setDate: any;
  separator: any;
  onClick: any;
  onBlur: any;
  setIsOpen: any;
  isOpen: any;
  isOpenMobile?: any;
  width?: number | string;
  doestOpen?: boolean;
  border?: boolean;
  popupClassName?: string;
  classNameContainer?: string;
  reservedDays?: any;
  onFocus?: any;
  onCloseMobile?: any;
};

const InputDate = forwardRef<any, InputDateProps>((props, ref) => {
  const { saveToSessionStorage,getFromSessionStorage} = useSessionStorage()
  const [calendarChanged, setCalendarChanged] = useState(false);
  const [value, setValue] = useState<any>(null);
  

  const { Alert, showAlert } = useAlert({ active: false, title: '', type: 'SUCCESS' })

  const calendarIcon = require('../../assets/svg/CalendarBlank.svg').default;


  const calendar = <img style={{ width: 24, height: 24 }} src={calendarIcon} alt="" />

  const directionIcon = (direction: string): string => {
    if (direction === 'left') {
      return require('../../assets/svg/calendar/caretLeft.svg').default;
    } else {
      return require('../../assets/svg/calendar/caretRight.svg').default;
    }
  }

  const breakpoint = useScreenWidth();

  const handleClickOutside = (event: MouseEvent) => {
    if ((!ref as any).current)
      props.setIsOpen(false);
  };


  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

    

  }, []);
  useEffect(() => {

    const getStorage = ()=>{
      const headerDate = getFromSessionStorage('dateHeader')
      const headerGuest = getFromSessionStorage('guest')
        const dateHeaderExist = JSON.stringify(headerDate) 
  
       if(dateHeaderExist!=='null'){
        
        const dayCheckIn = dayjs(headerDate.check_in);
        const dayCheckOut = dayjs(headerDate.check_out);
        props.setDate([dayCheckIn,dayCheckOut])
       }
        
       
  
  
    }
    getStorage()
  }, []);
  
   


  const isAnyDateDisabledInRange = (start: any, end: any): boolean => {
    const startDate = dayjs(start);
    const endDate = dayjs(end);

    // Ensure props.reservedDays exists and is an array
    if (props.reservedDays && Array.isArray(props.reservedDays)) {
      for (let date = startDate; date.isBefore(endDate) || date.isSame(endDate); date = date.add(1, 'day')) {
        if (props.reservedDays.includes(date.format('YYYY-MM-DD'))) {
          return true;
        }
      }
    }

    return false;
  };

  const navigate = useNavigate();


  const updateQueryParam = useUpdateQueryParams()

  return (
    <RangerPick
      width={props.width}
      open={props.isOpenMobile}
      popupClassName={props.popupClassName}
      className={props.classNameContainer ? props.classNameContainer : 'ranger-picker'}
      border={props.border}
      ref={ref}
      disabled={props.doestOpen}
      onCalendarChange={(val) => {
        props.setDate(val);
      }}
      name='data'
      locale={ptBr}
      onClick={() => {
        props.setIsOpen(true);
      }}
      onChange={(val) => {
        if (val && val[0] && val[1]) {
          if (isAnyDateDisabledInRange(val[0], val[1])) {
            props.setDate([null, null]);
            showAlert({ active: true, title: 'Ops! As datas selecionadas não estão disponíveis.', type: 'ERROR' })
          } else {
            setValue(val);
            if (val[0] && val[1]) {  
               saveToSessionStorage('dateHeader',
              {check_in: val[0].format('YYYY-MM-DD'),
              check_out:val[1].format('YYYY-MM-DD')})
             
            }
          }
        }
      }}
      clearIcon={false}
      separator={calendar}
      suffixIcon={calendar}
      nextIcon={<img style={{ marginRight: -50, marginTop: 8, height: 25, width: 25 }} src={directionIcon('right')} alt="" />}
      prevIcon={<img style={{ marginLeft: -50, marginTop: 8, height: 25, width: 25 }} src={directionIcon('left')} alt="" />}
      value={props.date || value}
      format="DD/MM/YYYY"
      placeholder={['Entrada', 'Saída']}
      disabledDate={(current) => {
        let reservedDays = props.reservedDays;
        let reservedDaysFormatted = [];

        if (reservedDays && reservedDays.length > 0) {
          reservedDaysFormatted = reservedDays.map((day: any) => {
            return dayjs(day).format('DD/MM/YYYY');
          });
        }

        const tooLate = props.date[0] && dayjs(current).diff(props.date[0], "day") >= 32;

        return reservedDaysFormatted.includes(dayjs(current).format('DD/MM/YYYY')) || dayjs().subtract(1, 'day').isAfter(current) || !!tooLate;
      }}
      inputReadOnly={true}
      renderExtraFooter={() => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              padding: '0px 16px 4px 16px',
              gap: '16px',
            }}
          >
            <Alert />
            <Button disabled={false} icon='' size='medium' type='secondary' title='Limpar datas'
              onClickButton={() => {
                props.setDate([null, null]);
              }}
            />
            {breakpoint && <Button disabled={false} icon='' size='medium' type='confirm' title='Fechar'
              onClickButton={props.onCloseMobile}
            />}
          </div>
        );
      }}
    />
  );
});

export default InputDate;
